import Breadcrumb from "../../Component/Breadcrumb";

function VisionMission() {
  return (
    <>
      <Breadcrumb>About /   Our Vision  & Values</Breadcrumb>
      <div className="innersec vision_mission">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>  Our Vision  & Values</h1>
            </div>

            <div className="row">
              {/* Vision Section */}
              <div className="col-lg-6 col-md-12">
                <div className="vision-card p-4 rounded-4 shadow-sm h-100">
                  <h4 className="vision-heading mb-3">
                    <i className=" me-2 text-primary"></i> Our Vision
                  </h4>
                  <p><b><i>At ST. JOSEPH’S SCHOOL we embark on the mission of:</i></b></p>


                  <ul class="ul-list">
                    <li>Integral development-physical, intellectual, mental and spiritual- of every child enrolled here</li>
                    <li>To make them responsible, broad-minded, patriotic and disciplined citizen of the country.</li>
                    <li>To make our children committed to the service of God and of the nation</li>
                    <li>To instill into them a spirit of compassion, unselfish service, dedication to duty, love for the fellow men and thirst for excellence and wisdom</li>
                  </ul>




                </div>
              </div>



              {/* Values Section */}
              <div className="col-lg-6 col-md-12">
                <div className="values-card p-4 rounded-4 shadow-sm h-100">
                  <h4 className="values-heading mb-3">
                    <i className=" me-2 text-danger"></i> Our Values
                  </h4>
                  <p><b><i>FOR THIS WE</i></b></p>


                  <ul class="ul-list">
                    <li>Recognize and encourage talents and foster an appreciation of creative ability of every child.</li>
                    <li>Stimulate and satiate intellectual curiosity.</li>
                    <li>Develop in the school a caring community, exercising concern and respect for the welfare of others.</li>
                    <li>Encourage children to appreciate the virtues of collaboration and initiation.</li>
                    <li>Offer a wide variety of high quality education and learning opportunities for children.</li>
                  </ul>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default VisionMission;
